import css from './BalloonBox.module.scss'
import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'
import { TextBoxInfoTypes } from 'types/layout'

import { BalloonSize, BalloonTipPosition, ComponentColor } from 'meta/backendControlled/structure'

import BalloonWrapper from 'components/Layout/BalloonWrapper'
import Img from 'components/Media/Img'

interface IProps {
  bgColor?: ComponentColor
  infoType: TextBoxInfoTypes
  title?: string
  noPadding?: boolean
  fullWidth?: boolean
}

const BalloonBox: React.FC<PropsWithChildren<IProps>> = ({
  children,
  bgColor = ComponentColor.white,
  infoType,
  title,
  noPadding = false,
  fullWidth = false,
}) => {
  return (
    <BalloonWrapper
      noPadding={noPadding}
      color={bgColor as ComponentColor}
      size={BalloonSize.small}
      tipPosition={BalloonTipPosition.right}
    >
      <div className={classNames(css.textboxes_balloonbox, { [css.noPadding]: noPadding, [css.fullWidth]: fullWidth })}>
        <div className={css.infoImg}>
          {infoType === 'info' && <Img src="/textboxes/textboxes_info.svg" />}
          {infoType === 'warning' && <Img src="/textboxes/textboxes_warning.svg" />}
          {infoType === 'error' && <Img src="/textboxes/textboxes_error.svg" />}
          {infoType === 'success' && <Img src="/textboxes/textboxes_success.svg" />}
        </div>

        {title && <div className={css.title}>{title}</div>}

        <div className={classNames(css.content, { [css.fullWidth]: fullWidth })}>{children}</div>
      </div>
    </BalloonWrapper>
  )
}

export default BalloonBox
